import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Libraries } from '../../../../dialogs/upload/upload/upload.component';
import { ResourceItemModel } from '../../../../models/resource';
import { IconTypes } from '../../../../standalones/components/pencil-icon/pencil-icon.component';
import { BulkUploadService } from '../bulk-upload-panel/services/bulk-upload.service';

@Component({
  selector: 'app-upload-panel',
  templateUrl: './upload-panel.component.html',
  styleUrls: ['./upload-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadPanelComponent {
  readonly isBulkUploadActive$ = this.bulkUploadService.isBulkUploadActive$;

  constructor(
    private translateService: TranslateService,
    private readonly bulkUploadService: BulkUploadService,
  ) {}

  @Output() closeSubmit = new EventEmitter<void>();

  uploadData = {
    title: this.translateService.instant('Upload'),
    libraries: [Libraries.COMPUTER, Libraries.PENCIL_FILES, Libraries.IMAGES, Libraries.CAMERA],
    type: [ResourceItemModel.IMAGE, ResourceItemModel.VIDEO, ResourceItemModel.DOCUMENT],
    newPdfFlow: true,
  };
  protected readonly IconTypes = IconTypes;
}
